var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-button", {
        staticStyle: { cursor: "pointer" },
        attrs: {
          type: "info",
          circle: "",
          loading: _vm.listLoading,
          icon: "el-icon-message",
        },
        on: { click: _vm.handleGetList },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            top: "2%",
            width: "80%",
            visible: _vm.dialogTableVisible,
            title: "活動推播歷史紀錄（" + _vm.list.length + "）",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                position: "relative",
                "min-height": "300px",
                height: "100%",
              },
            },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  attrs: {
                    size: "mini",
                    data: _vm.list,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                    height: "100%",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", label: "項次", width: "60" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.$index + 1))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "資料ID", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_c("span", [_vm._v(_vm._s(scope.row.id))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "推播時間", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              { attrs: { effect: "dark", type: "info" } },
                              [_vm._v(_vm._s(scope.row.recordDate))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "left", label: "旅遊團", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.travelID
                              ? _c("span", [
                                  _vm._v(
                                    "(ID:" +
                                      _vm._s(scope.row.travelID) +
                                      ")" +
                                      _vm._s(scope.row.travelName)
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "使用者名稱",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.userName))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "left", label: "優惠券連結", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: JSON.parse(scope.row.data).url,
                                  target: "_blank",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "coupon-link" },
                                  [
                                    _c("span", [_vm._v("優惠券連結")]),
                                    _c("el-icon", {
                                      staticStyle: { "margin-left": "2px" },
                                      attrs: { name: "link" },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "left", label: "推播標題", width: "155" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.subject))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "left", label: "推播內文", width: "450" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.content))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "成功筆數",
                      width: "80",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.successCount == 0
                              ? _c("span")
                              : _c(
                                  "el-tag",
                                  {
                                    attrs: { effect: "dark", type: "success" },
                                  },
                                  [_vm._v(_vm._s(scope.row.successCount))]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "失敗筆數",
                      width: "80",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.failureCount == 0
                              ? _c("span")
                              : _c(
                                  "el-tag",
                                  { attrs: { effect: "dark", type: "danger" } },
                                  [_vm._v(_vm._s(scope.row.failureCount))]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }